
"use strict"; // jshint ignore:line

import { Painting }           from '../classes/painting.js';
import { ObjectClickHandler } from '../../utils/object-click-handler.js'; 
import { CommentsHandler }    from '../services/CommentsService.js';

import {
	Math as THREEMath,
	Group,
	BoxGeometry,
	Vector3,
	Mesh,
	Plane,
	PlaneGeometry,
	LineSegments,
	EdgesGeometry,
	LineBasicMaterial,
	MeshPhongMaterial,
	MeshBasicMaterial
} from '../../../src/js/three.module.js';

export default function WallsHandlerService( $rootScope, userActionHistoryService, contextMenuService ) {
		
	WallsHandlerService.getInstance = () => this;

	var self = window.walls = window.wallService = this;

	WallService.call( this, {
		MIN_ANGLE_COS      : 0.89,
		MAX_PLANE_COS      : 0.1,
		MAX_PLANE_X_OFFSET : 0.01
	});

	userActionHistoryService.addActs({
		"additionalWall.create": {
			"undo": function(act){
				self.removeAdditionalWall( act.additionalWall );
			},
			"redo": function(act){
				var wall = new WallService.AdditionalWall( act.edgeA, act.edgeB, act.bottomY, act.height, act.depth );
				self.addAdditionalWall( wall );
			}
		},
		"additionalWall.remove": {
			"undo": function(act){ userActionHistoryService.acts[ "additionalWall.create" ].redo( act ); },
			"redo": function(act){ userActionHistoryService.acts[ "additionalWall.create" ].redo( act ); }
		},
		"additionalWall.setEdge": {
			"undo": function( act, obj ){ if( obj = act.additionalWall ) obj.setEdge( act.end, act.prev_edge ); },
			"redo": function( act, obj ){ if( obj = act.additionalWall ) obj.setEdge( act.end, act.edge ); }
		},
		"additionalWall.setWidth": {
			"do": function( wall, width ){
				wall = self.walls[ wall.uuid ] || wall;
				userActionHistoryService.addUndo("additionalWall.setWidth", { uuid: wall.uuid, prev_width: wall.width, curr_width: wall.width = width });
				wall.setWidth();
			},
			"undo": function( act ){ self.walls[ act.uuid ].setWidth( act.prev_width ); },
			"redo": function( act ){ self.walls[ act.uuid ].setWidth( act.curr_width ); }
		},
		"additionalWall.setHeight": {
			"do": function( wall, height ){
				wall = self.walls[ wall.uuid ] || wall;
				userActionHistoryService.addUndo("additionalWall.setHeight", { uuid: wall.uuid, prev_height: wall.height, curr_height: wall.height = height });
				wall.setHeight();
			},
			"undo": function( act ){ self.walls[ act.uuid ].setHeight( act.prev_height ); },
			"redo": function( act ){ self.walls[ act.uuid ].setHeight( act.curr_height ); },
			"$postCallback": function(act){ self.walls[ act.uuid ].refresh(); }
		},
		"additionalWall.setDepth": {
			"do": function( wall, depth ){
				wall = self.walls[ wall.uuid ] || wall;
				userActionHistoryService.addUndo("additionalWall.setDepth", { uuid: wall.uuid, prev_depth : wall.depth, curr_depth: wall.depth = depth });
				wall.setDepth();
			},
			"undo": function( act ){ self.walls[ act.uuid ].setDepth( act.prev_depth ); },
			"redo": function( act ){ self.walls[ act.uuid ].setDepth( act.curr_depth ); },
			"$postCallback": function(act){ self.walls[ act.uuid ].refresh(); }
		},
		"additionalWall.setColor": {
			"do": function( wall, color ){
				wall = self.walls[ wall.uuid ] || wall;
				userActionHistoryService.addUndo("additionalWall.setColor", {
					uuid       : wall.uuid,
					prev_color : "#"+wall.material.color.getHexString(),
					curr_color : "#"+wall.material.color.set( color ).getHexString()
				});
			},
			"undo": function( act ){ self.walls[ act.uuid ].setColor( act.prev_color ); },
			"redo": function( act ){ self.walls[ act.uuid ].setColor( act.curr_color ); }
		},
		"additionalWall.setBottomY": {
			"do": function( wall, bottomY ){
				wall = self.walls[ wall.uuid ] || wall;
				userActionHistoryService.addUndo("additionalWall.setBottomY", {
					uuid         : wall.uuid,
					prev_bottomY : wall.bottomY,
					curr_bottomY : (wall.bottomY = bottomY)
				});
				wall.setEdges();
			},
			"undo": function( act ){ self.walls[ act.uuid ].bottomY = act.prev_bottomY; },
			"redo": function( act ){ self.walls[ act.uuid ].bottomY = act.curr_bottomY; },
			"$postCallback": function( act ) { self.walls[ act.uuid ].setEdges(); }
		}
	});

	contextMenuService.buildTemplateScope([ "templates/context-modals/additionalWall.html" ], {
		onOpen: function() {
			var self = this;

			this.__open_tab = 'settings';

			this.changeTab = function( tab ) {
				self.__open_tab = tab;
			};

			this.selectedObject = null;
			this.selectedObject_cloneable = false;

			try {
				var obj = window.entitySelectionService.selected_entity;

				if (!obj) return null;

				/** Lisäseinää ei hyväksytä valituksi objektiksi, koska lähtökohtaisesti haluttaisiin
				 * objektilla olevan tasan yksi "sijainti", ei kahta reunaa
				 */
				if (obj instanceof WallService.AdditionalWall) return null;

				this.selectedObject = obj;
				this.__open_tab = 'selected_object';

				if (obj instanceof AdditionalObject) {
					this.selectedObject_cloneable = true;
				}
			} catch (error) {}
		},

		__filterWValue: function( v, step ){
			step = step || 1/1e3;
			return Math.max( step, Math.round(v / step) * step );
		}
	});

	this.onAdditionalWallsChanged = function() {
		$rootScope.$broadcast( "additionalWallsChanged" );
	};
}

WallsHandlerService.$inject = [ "$rootScope", "userActionHistoryService", "contextMenuService" ];

WallsHandlerService.prototype = Object.create( WallService.prototype );

export function WallService( options ) {

	this.walls = {};

	this.additional_walls = {};
	this.additional_walls_meshs = new Group();

//	this.additional_wall_selection = null;

	this.oeuvres = null;

	this.options = {};
    this.setOptions( options );

	this.options.additional_wall_default_height = this.options.additional_wall_default_height || 2;
	this.options.additional_wall_default_depth  = this.options.additional_wall_default_depth  || 0.08;
	this.options.additional_wall_default_color  = this.options.additional_wall_default_color  || 0xffffff;
}
WallService.prototype.setOptions = function( options ){
	if( typeof options == "object" ){
        angular.merge( this.options, options );
    }
};
WallService.prototype.init = (function(){
	var inited = false;
	return function( oeuvres, options ){

        this.setOptions( options );

		if( !this.oeuvres ) this.oeuvres = oeuvres;
		else for( var i in oeuvres || [] ){
			this.oeuvres[ oeuvres[i].uid ] = this.oeuvres[ oeuvres[i].uid ] || oeuvres[i];
		}

		if( !inited ){
			window.scene.add( this.additional_walls_meshs );
		}

		this.refresh();
		this.clearEmpties();
		for( var uuid in this.walls ) this.walls[uuid].refresh();

		inited = true;
	};
})();
WallService.prototype.refresh = function( changed, intersect ){
	var dropouts = Object.keys( this.oeuvres );

	if (changed) {
		if (changed.$wall) delete changed.$wall.oeuvres[ changed.uid ];

		changed.$wall = null;

		dropouts = [ changed.uid ];
	} else {
		for (var uuid in this.walls) {
			// Tiputetaan kyydistä epäsopivat
			this.walls[ uuid ].validateOeuvres();

			for (var uid in this.walls[ uuid ].oeuvres) {
				dropouts.splice( dropouts.indexOf( uid ), 1 );
			}
		}
	}

	// oeuvres_uids sisältää "hukassa olevat" teokset;
	for (var i in dropouts) {
		var oeuvre = this.oeuvres[ dropouts[i] ];

		// Jos ei asetettu niin ei millän seinälläkään
		if (!oeuvre.isSetted) continue;

		// Jos ei ole seinäteos niin ei voi olla seinälläkään
		if (!(oeuvre instanceof Painting)) continue;

		var wall = this.findCompatibleWall( oeuvre ) || this.addWallByPainting( oeuvre, intersect );

		if (wall) {
			oeuvre.$wall = wall;
			oeuvre.$wall.oeuvres[ oeuvre.uid ] = oeuvre;
		}
	}
};
WallService.prototype.clearEmpties = function() {
	for (var uuid in this.walls) {
		if (this.walls[ uuid ] instanceof WallService.AdditionalWall) continue;
		if (this.walls[ uuid ].oeuvresCount() > 0) continue;

		this.removeWall( uuid );
	}
};

WallService.prototype.get = function( wall ){
	return this.walls[ wall instanceof WallService.Wall ? wall.uuid : wall ];
};
WallService.prototype.findCompatibleWall = function( oeuvre ){
    if( window.n_test_23_1_2018 ){
// 22.1.2019 tutkittu (ja ylempi kommentoitu) miksi teos tunnistetaan väärille seinille
    	for( var uuid in this.walls ){
    		if( this.walls[uuid].isCompatible( oeuvre )){
    			return this.walls[uuid];
    		}
    	}
    } else {
        var _walls = [];

		for (let uuid in this.walls) {
			if (this.walls[uuid] instanceof WallService.AdditionalWall && this.walls[uuid].isCompatible( oeuvre )) {
				_walls.push( this.walls[ uuid ]);
			}
		}

		for (let uuid in this.walls) {
			if (!(this.walls[uuid] instanceof WallService.AdditionalWall) && this.walls[uuid].isCompatible( oeuvre )) {
				_walls.push( this.walls[ uuid ]);
			}
		}

        _walls.sort(function(a, b){ return Math.abs(a.x)-Math.abs(b.x); });
        if( _walls.length > 1 ) console.error( "Teos tulkittu sopivan useammalle kuin yhdelle seinälle!", oeuvre, _walls, _walls.map(w=>w.getPlanePosition&&w.getPlanePosition( oeuvre.mesh.position, oeuvre.mesh.rotation )));
//        else if( _walls.length == 1 ) console.warn( oeuvre, _walls[0], _walls[0].getPlanePosition( oeuvre.mesh.position, oeuvre.mesh.rotation ));
        return _walls[ 0 ];
    }
};

WallService.prototype.addWall = function( wall ){
	if( wall instanceof WallService.Wall ){
		this.walls[wall.uuid] = wall;
	} else if( wall instanceof WallService.AdditionalWall ){
		this.addAdditionalWall( wall );
	}
}
WallService.prototype.addAdditionalWall = function( wall ){
	this.walls[wall.uuid] = wall;
	this.additional_walls[wall.uuid] = wall;
	this.additional_walls_meshs.add( wall.mesh );

	window.ContextMenuService.init(
		"preview-additionalWall-"+wall.uuid,
		"templates/context-modals/additionalWall.html", {
			wallsService: this,
			wall: wall
		}
	);

	this.onAdditionalWallsChanged();
};
WallService.prototype.addWallByPainting = function( oeuvre, intersect ){
	if(!(oeuvre instanceof Painting )) return null;

	var wall;
	switch( intersect && intersect.object && intersect.object.userData && intersect.object.userData.type ){
		case "additionalWall":
			wall = intersect.object.userData.obj;
			break;
		default:
			wall = new WallService.Wall( oeuvre, this.options );
	}

	return this.walls[ wall.uuid ] = wall;
};
WallService.prototype.removeWall = function( wall ){
	if( typeof wall == "string" ) wall = this.walls[ wall ];
	if( !wall ) return console.error("oöihöhioc äo-ijhnsgÄPhikg");

	var uuid = wall.uuid;

	if( helpers.byParent[ uuid ]) helpers.removeByParent( uuid );

	delete this.walls[ uuid ];
};
WallService.prototype.removeAdditionalWall = function( uuid ){
	if( typeof uuid == "object") return this.removeAdditionalWall( uuid.uuid );

	var wall = this.additional_walls[ uuid ];

	if (!wall) return console.warn( "WallService.removeAdditionalWall :: Failed to remove, wall '"+uuid+"' does not found" );

	wall.$$selected = false;
	wall.$$deleted  = true;

	helpers.removeByParent( uuid );

	this.additional_walls_meshs.remove( wall.mesh );

	for( var uid in wall.oeuvres ){
		wall.oeuvres[uid].isSetted = wall.oeuvres[uid].mesh.visible = false;
	}

	window.ContextMenuService.destroy( "preview-additionalWall-"+uuid );

	delete this.additional_walls[ uuid ];
	delete this.walls[ uuid ];

	this.onAdditionalWallsChanged();
};

WallService.prototype.solveWall = function( uuid ){
	uuid = uuid.uuid || uuid || null;

	if (typeof uuid != "string")  throw "Invalid argument!"

	return this.additional_walls[ uuid ] || null;
};

WallService.prototype.showHelpersOnWall = function( wall ){
	return this.showHelpersOnWalls([ wall ]);
};

WallService.prototype.showHelpersOnWalls = function( walls ){
	return WallService.showHelpersOnWalls( walls || this.walls );
};

/*****************************************************/

WallService.showHelpersOnWalls = function showHelpersOnWalls( walls ) {
	for (let i in walls) {
	    for (let uid in walls[i].oeuvres) {
	        helpers.refreshOeuvreHelper( walls[i].oeuvres[uid] );
	    }
	}

	for (let i in walls) {
	    for (let uid in walls[i].oeuvres) {
			walls[i].oeuvres[uid].showHelpers();
	    }
	}

	console.warn( "WallService.showHelpersOnWalls :: Not Implemented! Does not show oeuvreWallEdgeLines yet." );
};

/*****************************************************/

WallService.WallProto = function( options ){
	this.uuid    = THREEMath.generateUUID();
	this.oeuvres = {};
	this.title   = null;

	this.options = options || walls.options;
	for( var key in walls.options ){
		if( this.options[key] == null ) this.options[key] = walls.options[key];
	}

	this.showHelpers = WallService.showHelpersOnWalls.bind( null, [this] );
};

// Lisätään teos, palautetaan virhe jos ei sopiva
WallService.WallProto.prototype.add = function( oeuvre ){

	if( this.isCompatible( oeuvre )){
		this.oeuvres[ oeuvre.uid ] = oeuvre;
		oeuvre.$wall = this;
		return true;
	}
	return false;
};
// Poistetaan epäsopivat teokset
WallService.WallProto.prototype.validateOeuvres = function(){
	for( var uid in this.oeuvres ){
		if( !this.isCompatible( this.oeuvres[ uid ] )){
			this.oeuvres[ uid ].$wall = null;
			delete this.oeuvres[ uid ];
		}
	}
};
WallService.WallProto.prototype.changeUuid = function( uuid ){
	if( helpers.byParent[ this.uuid ]){
		helpers.byParent[ uuid ] = helpers.byParent[ this.uuid ];
		delete helpers.byParent[ this.uuid ];
	}

	this.uuid = uuid;
	if( this.mesh && this.mesh.uuid ) this.mesh.uuid = this.uuid;
};
WallService.WallProto.prototype.oeuvresCount = function(){
	return Object.keys( this.oeuvres ).length;
};
WallService.WallProto.generateMaterial = function( material ) {
	return new MeshPhongMaterial( material );
}

/*
██     ██  █████  ██      ██
██     ██ ██   ██ ██      ██
██  █  ██ ███████ ██      ██
██ ███ ██ ██   ██ ██      ██
 ███ ███  ██   ██ ███████ ███████
*/
WallService.Wall = function( oeuvre, options ){
	WallService.WallProto.call(this, options);

	this.rotation = oeuvre.mesh.rotation.clone();
	this.position = oeuvre.mesh.position.clone();
	this.normal   = new Vector3( 0, 0, 1 ).applyEuler( oeuvre.mesh.rotation );

	this.mesh = new Mesh(
		new PlaneGeometry( 1, 1 ),
		new MeshBasicMaterial({
			wireframe : true,
			color     : 0xffff00,
			depthTest : false
	}));
	this.mesh.position.copy(this.position);
	this.mesh.rotation.copy(this.rotation);

	this.mesh.visible = false;

	if (oeuvre.uid) {
		this.oeuvres[ oeuvre.uid ] = oeuvre;
	}

	this.$parent = null;
	this.refresh();
};
WallService.Wall.prototype = Object.create( WallService.WallProto.prototype );

WallService.Wall.prototype.refresh = function(){

	var count = Object.keys( this.oeuvres ).length;

	if (count == 0) return;

	var oeuvres = this.oeuvres;

	var point = Object.keys( oeuvres ).map(function( uid ) {
		return oeuvres[uid].mesh.position;
	}).reduce(function(a,b){
		return a.add(b);
	}, new Vector3()).multiplyScalar( 1 / count );

	this.mesh.position.copy( this.position.copy( point ));
};
WallService.Wall.prototype.refreshOeuvres = function(){};

WallService.Wall.prototype.isCompatible = function( oeuvre ){
	if(!( oeuvre instanceof Painting )){
		return false;
	}

	if( this.$parent instanceof WallService.AdditionalWall ){
		return this.$parent.isCompatible( oeuvre );
	}

	// Käsitellään seinäpinnan sekä teoksen normaalien ero
	var other_rot_vec = new Vector3( 0, 0, 1 ).applyEuler( oeuvre.mesh.rotation );
	if( this.options.MIN_ANGLE_COS > other_rot_vec.dot( this.normal )) return false;

	// Käsitellääno oletettu seinäpinnan suuntaisen janan ja teoksen normaalin kohtisuoruus
	var other_pos_vec = this.position.clone().sub( oeuvre.mesh.position ).normalize();
	if( this.options.MAX_PLANE_COS < Math.abs(other_pos_vec.dot( other_rot_vec )) ) return false;

	return true;
};

/*
 █████  ██████  ██████  ██ ████████ ██  ██████  ███    ██  █████  ██      ██     ██  █████  ██      ██
██   ██ ██   ██ ██   ██ ██    ██    ██ ██    ██ ████   ██ ██   ██ ██      ██     ██ ██   ██ ██      ██
███████ ██   ██ ██   ██ ██    ██    ██ ██    ██ ██ ██  ██ ███████ ██      ██  █  ██ ███████ ██      ██
██   ██ ██   ██ ██   ██ ██    ██    ██ ██    ██ ██  ██ ██ ██   ██ ██      ██ ███ ██ ██   ██ ██      ██
██   ██ ██████  ██████  ██    ██    ██  ██████  ██   ████ ██   ██ ███████  ███ ███  ██   ██ ███████ ███████
*/
WallService.AdditionalWall = function( edgeA, edgeB, bottomY, height, depth ) {
	WallService.WallProto.call( this, walls.options );

	new ObjectClickHandler().attachTo( this );

	this.comments = new CommentsHandler( this );

    this.isAdditionalWall = true;

	this.edgeA   = edgeA;
	this.edgeB   = edgeB;
	this.bottomY = bottomY;

	this.width   = this.edgeA.distanceTo( this.edgeB );
	this.height  = height || helpers.options.additional_wall_default_height;
	this.depth   = depth  || helpers.options.additional_wall_default_depth;

	this.geometry = new BoxGeometry( 1, 1, 1 );
	this.material = WallService.WallProto.generateMaterial({ color: walls.options.additional_wall_default_color });
	this.mesh     = new Mesh( this.geometry, this.material );
	this.mesh.castShadow    = true;
	this.mesh.receiveShadow = true;
	this.mesh.userData.type = "additionalWall";
	this.mesh.userData.wall = true;
	this.mesh.userData.obj  = this;

	this.uuid = this.mesh.uuid;

	this.sides         = { front: {}, back: {}, left: {}, right: {} };
	this.$sideByOeuvres = {};

	/*this.mesh.add( this.wireframe = new THREE.Mesh( this.geometry, new THREE.MeshBasicMaterial({
		color     : 0xffff00,
		wireframe : true
	})));*/

	this.mesh.add( this.wireframe = new LineSegments( new EdgesGeometry( this.geometry ), new LineBasicMaterial({
		color     : 0xffff00,
	})));
	this.wireframe.visible = false;

	this.refresh();
};
WallService.AdditionalWall.prototype = Object.create( WallService.WallProto.prototype );

WallService.AdditionalWall.prototype.refreshOeuvres = function(){
	for (let side in this.sides)
		for (let uid in this.sides[ side ])
			delete this.sides[ side ][ uid ];

	this.$sideByOeuvres = {};

	var side, oeuvre;
	var this_rot_vec = new Vector3(0,0,1).applyEuler( this.mesh.rotation );

	for (let uid in this.oeuvres) {
		oeuvre = this.oeuvres[uid];
		side = null;

		var other_rot_vec = new Vector3(0,0,1).applyEuler( oeuvre.mesh.rotation );
		var dot = other_rot_vec.dot( this_rot_vec );

		var pos = this.mesh.worldToLocal(oeuvre.mesh.position.clone()).multiply(this.mesh.scale.clone());

		if (dot >= 0.9) {
			let exp_z_offset = Math.abs( this.mesh.scale.z / 2 ); // @TODO: Z_offset
			if (Math.abs( exp_z_offset - pos.z ) <= 0.01) {
				side = "front";
				pos.z = 0;
			}
		} else if (dot <= -0.9) {
			let exp_z_offset = Math.abs( this.mesh.scale.z / 2 ); // @TODO: Z_offset
			if (Math.abs( exp_z_offset + pos.z ) <= 0.01) {
				side = "back";
				pos.z = 0;
				pos.x = -pos.x
			}
		} else if (Math.abs(dot) <= 0.1) {
			var leftvec = this_rot_vec.clone().applyAxisAngle(new Vector3(0,1,0), Math.PI/2);
			if( leftvec.dot( other_rot_vec ) < 0 ) {
				side = "right";

				pos = new Vector3( pos.z, pos.y, 0 );
			} else {
				side = "left";

				pos = new Vector3( -pos.z, pos.y, 0 );
			}
		}

		if (side) {
			this.$sideByOeuvres[uid] = side;
			this.sides[side][uid] = {
				oeuvre : oeuvre,
				pos    : pos
			};
		} else {
			// this.oeuvres'ssa on teos, joka ei tunnu sopivan seinälle! -> Irrotetaan seinästä.

			delete this.oeuvres[uid];

			if (oeuvre.$wall == this) {
				oeuvre.$wall = null;
			} else if (oeuvre.$wall) {
				// Teoksella "on seinä", mutta se ei ole tämä seinä!
				console.warn( "Not Implemented" );
			}
		}
	

	}
};

WallService.AdditionalWall.prototype.resetOeuvres = function(){
	var axplus = {
		"front" : { z: this.depth/2, yp: 0 },
		"back"  : { z: this.depth/2, yp: Math.PI },
		"left"  : { z: this.width/2, yp: Math.PI / -2 },
		"right" : { z: this.width/2, yp: Math.PI / -2 }
	};

	for (var uid in this.oeuvres) {
		var npos = this.mesh.position.clone();
		var nrot = this.mesh.rotation.clone();
		var side = this.$sideByOeuvres[ uid ];

		if (!side) {
			console.warn("Oeuvre is marked to be on additional wall, but does not seems to be on any side. Unsetting from wall", this, this.oeuvres[ uid ]);
			this.oeuvres[ uid ].$wall = null;
			delete this.oeuvres[ uid ];
			continue;
		}

		// Teoksen normaalia kierretään lisäseinän "etuseinän" normaalista s.e. normaali on tietylle reunalle sopiva
		nrot.y += axplus[side].yp;

		// Teoksen sijainti tietyllä reunalla
		var pos = this.sides[side][uid].pos.clone();

		// Teoksen sijainti tietyllä eeunalla suhteessa lisäseinän keskipisteeseen
		pos.setZ( axplus[side].z );

		pos.applyEuler( nrot );

		npos.add( pos );

		this.oeuvres[ uid ].mesh.position.copy( npos );
		this.oeuvres[ uid ].mesh.rotation.copy( nrot );
	}
};

WallService.AdditionalWall.prototype.refresh = function(){

	this._color = "#"+this.mesh.material.color.getHexString();

	this.$helper_box && this.$helper_box.update();

	this.$helper_axis && this.$helper_axis.position.copy(this.mesh.position);
	this.$helper_axis && this.$helper_axis.rotation.copy(this.mesh.rotation);
};
WallService.AdditionalWall.prototype.setEdge = function( end, edge ){
	return this.setEdges( end == "A" && edge, end == "B" && edge );
};
WallService.AdditionalWall.prototype.setEdges = function( edgeA, edgeB ){

	if( edgeA && !edgeB ) this.$latestEdgeEdited = "A";
	if( edgeB && !edgeA ) this.$latestEdgeEdited = "B";

	(edgeA = edgeA ? this.edgeA.copy( edgeA ) : this.edgeA).y = this.bottomY;
	(edgeB = edgeB ? this.edgeB.copy( edgeB ) : this.edgeB).y = this.bottomY;

	this.width = this.edgeA.distanceTo( this.edgeB );

	var cvec = this.edgeB.clone().sub( this.edgeA ).normalize();
	var cang = Math.atan2( cvec.z, cvec.x ) - Math.PI/2;

	this.mesh.setRotationFromAxisAngle( new Vector3( 0, -1, 0 ), cang + Math.PI/2 );
	this.mesh.position.copy( this.edgeA.clone().add( this.edgeB.clone().sub( this.edgeA ).multiplyScalar( 0.5 ))).y += this.height/2;
	this.mesh.scale.x = this.width;
	this.mesh.scale.y = this.height;
	this.mesh.scale.z = this.depth;

	this.mesh.updateMatrixWorld();

	this.refresh();
	this.resetOeuvres();
	this._onEdgesSetted && this._onEdgesSetted();
};
WallService.AdditionalWall.prototype.setHeight = function( val ){
	if(!isNaN(val = parseFloat(val))) this.height = val;
	this.setEdges();
};
WallService.AdditionalWall.prototype.setDepth = function( val ){
	if(!isNaN(val = parseFloat(val))) this.depth = val;
	this.setEdges();
};
WallService.AdditionalWall.prototype.setWidth = function( width, edgeLetter ){

	if( width == null ) width = this.width = this.width || this.edgeA.distanceTo( this.edgeB );

	if( isNaN( width = parseFloat( width ))) throw new Error("AdditionalWall.setWidth :: Invalid argument, width is NaN");

	var staticEdge, dynamicEdge;
	switch( edgeLetter = edgeLetter || this.$latestEdgeEdited ){
		case "A":
			staticEdge  = this.edgeB;
			dynamicEdge = this.edgeA;
			break;
		case "B":
			staticEdge  = this.edgeA;
			dynamicEdge = this.edgeB;
			break;
		default:
			staticEdge  = this.edgeA;
			dynamicEdge = this.edgeB;
//			@TODO: Laajenna "keskeltä" (eka toinen width-(width-nwidth)/2 ja sit toinen nwidth?)
//			throw new Error("AdditionalWall.setWidth :: Invalid Edge");
	}

	var oldWidth = dynamicEdge.setY( staticEdge.y ).sub( staticEdge ).length();
	var newWidth = dynamicEdge.normalize().multiplyScalar( width ).length();

	dynamicEdge.add( staticEdge );

	this.setEdges();

	console.log("WallService.setWidth :: Setted wall length(w="+ width +")", "old length: "+oldWidth, "new length: "+newWidth);
};
WallService.AdditionalWall.prototype.setColor = function( color ){
	this.material.color.set( color );
};
WallService.AdditionalWall.prototype.setPosition = function( position ){

	var edgeAtoB = this.edgeB.clone().sub( this.edgeA ).normalize();

	this.setEdges(
		position.clone().addScaledVector( edgeAtoB, -this.width / 2 ),
		position.clone().addScaledVector( edgeAtoB, +this.width / 2 )
	);
};
WallService.AdditionalWall.prototype.select = function(){
	this.wireframe.visible = true;
};
WallService.AdditionalWall.prototype.unselect = function(){
	this.wireframe.visible = false;
};

WallService.AdditionalWall.prototype.getPlanePosition = (function() {

	// Kohdeobjektin nomraalivektori
	var other_normal = new Vector3();

	// Seinän pintaa mukaileva pinta
	var plane = new Plane();

	var plane_point = new Vector3();
	
	// Piste lisäseinän pinnan keskipisteen kohdalla s.e. piste on offset'n matkan päässä lisäseinän pinnasta
	var plane_point_position = new Vector3();
	
	// Vektori em. seinän pinnan edessä olevasta pisteestä teoksen sijaintiin
	var delta_vec = new Vector3();

	return function( position, rotation, z_offset ){

		rotation = rotation || this.mesh.rotation.clone();
		z_offset = z_offset   || 0;

		// toisen objektin normaalivektori
		other_normal.set( 0, 0, 1 ).applyEuler( rotation ).normalize();

		// Seinän normaalivektori
		plane.normal.set( 0, 0, 1 ).applyEuler( this.mesh.rotation ).normalize();

		// Vektorien pistetulo
		var dot = other_normal.dot( plane.normal );

		
		/*
		 * Purkka- ja virhealtis toteutus "seinäpinnan sisällä" olemisen tarkistamiseksi
		 * plane_point_max_horizontal_delta = "suurin etäisyys jolla voidaan plane_point'sta olla"
		 */
		var plane_point_max_horizontal_delta;

		var plane_normal_scalar, side;

		// @NOTE: huomioi vain "etupuolen" ja "takapuolen"
		// Tarkastellaan, ovatko teoksen ja seinä pinnan normaalit riittävän samansuuntaiset
		// tarkistamalla onhan normaalien pistetulo riittävän lähellä lukua 1 tai -1
		if (this.options.MIN_ANGLE_COS < Math.abs( dot )) {

			plane_normal_scalar = this.depth / 2 + z_offset;
			plane_point_max_horizontal_delta = Math.sqrt( Math.pow( this.width, 2 ) + Math.pow( this.height, 2 )) / 2;

			if (dot > 0) {
				side = "front"
			} else {
				side = "back";

				plane_normal_scalar = -plane_normal_scalar;
			}

		} else if (this.options.MIN_ANGLE_COS < (1 - Math.abs( dot ))) {
			// Normaalien pistetulon mukaan teos ja seinä ovat tasan eri suuntiin (sivutahkojen suuntaisesti) 

			plane_normal_scalar = this.width / 2 + z_offset;
			plane_point_max_horizontal_delta = Math.sqrt( Math.pow( this.depth, 2 ) + Math.pow( this.height, 2 )) / 2;

			if (dot > 0) {
				side = "left"
				plane_normal_scalar = -plane_normal_scalar;
			} else {
				side = "right";
			}

			// Koska käsitellään "sivuseinää", käännetään normaali "vasemmalle"
			plane.normal.applyAxisAngle( new Vector3( 0, 1, 0), Math.PI / 2 );
		} else {
			return null;
		}

		if (side) {
			// Koska tiedetään, että ollaan *jollain* pinnalla, oletetaan sijaintitetojen olevan kunnossa

			// Tarkasteltavan pinnan keskpisteen sijainti maailmankoordinaatistossa
			plane_point.copy( plane.normal ).multiplyScalar( plane_normal_scalar ).add( this.mesh.position );

			// Vektori teoksesta seinäpinnan keskipisteeseen maailmankoordinaatistossa
			delta_vec.copy( position ).sub( plane_point );

			// Tarkastetaan, että vektori teoksen keskipisteen ja seinäpinnan keskipisteen päällä olevan pisteen välillä
			// sekä seinän normaali ovat riittävän vastakkaiset. "Piste seinllä"
			if (Math.abs( delta_vec.clone().normalize().dot( other_normal )) > this.options.MIN_ANGLE_COS) return null;

			plane.projectPoint( delta_vec, plane_point_position );

			console.log( "plane_point_position", plane_point_position, "side", side );


			// Tarkatetaan, etä sijainti on korkeussuunnassa edes mahdollisesti seinällä
			if (Math.abs( plane_point_position.y ) > this.height / 2) return false;


			// @TODO: Korvaa oikealla tarkistuksella!!
			// Tarkastetaan, että teos voi sijaintinsa (etäisyytensä) puolesta olla mahdollisesti seinällä
			if (delta_vec.length() > plane_point_max_horizontal_delta) return false;


			return { position: plane_point_position, side: side };
		}
	}
})();

WallService.AdditionalWall.prototype.isCompatible = function( oeuvre ){

	// var plane_point = this.getPlanePosition( oeuvre.mesh.position, oeuvre.mesh.rotation );
	var plane_point = this.getPlanePosition( oeuvre.mesh.position, oeuvre.mesh.rotation, oeuvre.z_offset );

	if (!plane_point) return false;

	var side = plane_point.side;

	if (side == "front" || side == "back") {
		if (side == "front") { } else { }
	} else if (side == "left" || side == "right") {
		if (side == "left") { } else { }
	} else {
		return false
	}

	return true;
};







class AdditionalWallPlane extends Plane {
	constructor() {
		super();
	}
	refresh() {
	}
}
WallService.AdditionalWallPlane = AdditionalWallPlane;
